// STATE: 10% of penal amount: $50 minimum regardless of penal amount.
// In accordance with California Proposition 103, the Bail Agent may offer rebates. 
// IMMIGRATION: $100 execution fee plus up to 15% of the penail amount. 
//              $100 miinimum.
//              Those bonds will full cash collateral, regardless on the penal amount 
//              of the bond, will be charged a flat $295 premium.

/* eslint-disable */
export const equation = ({ bondValue, premium, type, additional }) => {
  let value = null
  let condition = null
  let minimum = 50
  if (type === 'STATE') {
    value = (bondValue * .1)
    if (value < 50) {
      value = 50
      condition = 'Minimum not met'
    }
  } else if (type === 'IMMIGRATION') {
    value = (bondValue * .15)
    minimum = 100
    if (value < 100) {
      value = 100
      condition = 'Minimum not met'
    }
    value += 100
  }
  return { value, minimum, condition }
}
/* eslint-enable */

export default equation